import Editor, { BtnBulletList, BtnNumberedList, EditorProps, Toolbar } from 'react-simple-wysiwyg';
import sanitizeHtml from 'sanitize-html';
import './RichTextEditor.css';

type RichTextEditorProps = {
  label?: string;
  dataTestId?: string;
} & EditorProps;

export const santizeInput = (html: string) => {
  return sanitizeHtml(html, {
    allowedTags: ['div', 'ul', 'ol', 'li'],
  });
};

export const isEmpty = (html: string) => {
  return (
    html === undefined ||
    html
      .replaceAll('<div>', '')
      .replaceAll('</div>', '')
      .replaceAll('<br>', '')
      .replaceAll('&nbsp;', '')
      .trim() === ''
  );
};

/** An intentionally *very* simple multiline text editor with barebones formatting support for just
 * bullet and numbered lists. Built using `react-simple-wysiwyg`, which is admittedly low-popularity
 * and unlikely to see much maintenance.  Unlikely a problem if we continue to keep requirements extremely
 * basic, but if we find ourselves needing a full RTE lets look into other libraries like Tiptap, LexKit,
 * or other fully-featured React RTE editors. */
export const RichTextEditor = ({ label, ...props }: RichTextEditorProps) => {
  return (
    <div className='flex flex-col gap-4'>
      {label && (
        <div className={'text-sm text-gray-500 font-medium flex flex-row justify-between'}>
          {label}
        </div>
      )}
      <Editor {...props} data-testid={props.dataTestId}>
        <Toolbar>
          <BtnBulletList />
          <BtnNumberedList />
        </Toolbar>
      </Editor>
    </div>
  );
};
